// extracted by mini-css-extract-plugin
export var btn = "Cases-module--btn--1061c";
export var btnOutlinePrimary = "Cases-module--btn-outline-primary--65138";
export var btnPrimary = "Cases-module--btn-primary--23c6f";
export var card = "Cases-module--card--58715";
export var formSelect = "Cases-module--form-select--5b0ec";
export var grid = "Cases-module--grid--12d74";
export var head = "Cases-module--head--022e7";
export var heading = "Cases-module--heading--638f1";
export var inner = "Cases-module--inner--be05c";
export var lead = "Cases-module--lead--7784c";
export var link = "Cases-module--link--338fd";
export var metric = "Cases-module--metric--e0e44";
export var section = "Cases-module--section--bb043";
export var text = "Cases-module--text--f6238";
export var unit = "Cases-module--unit--fb99d";
export var value = "Cases-module--value--4e3d4";